import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";

const Summery = ({ data }) => {
  const [liked, setLiked] = useState(false);
  useEffect(() => {
    setLiked(data?.liked ? true : false);
  }, [data?.liked]);

  const toggleLike = () => {};
  return (
    <div className="bg-white rounded-md py-3 mt-5 md:mt-0 md:px-10 px-4 flex flex-col gap-3">
      <div className="w-full flex justify-between items-center">
        <div className="flex gap-3 items-center">
          <img width={10} src="/images/icons/bookmark.svg" alt="bookmark" />
          <span className="text-sm text-[#4D4D4D]"> condition of good :</span>
          <span className="text-sm text-[#FF3400] font-bold">New Item</span>
        </div>
        <div className="flex gap-3 items-center">
          <IconButton
            onClick={toggleLike}
            sx={{ display: { md: "block", xs: "none" } }}
          >
            {!liked ? (
              <img width={17} src="/images/icons/emptyHeart.svg" alt="liked" />
            ) : (
              <img width={17} src="/images/icons/fullHeart.svg" alt="liked" />
            )}
          </IconButton>
          {/*    <IconButton>
            <img width={17} src="/images/icons/a.svg" alt="ads" />
          </IconButton> */}
        </div>
      </div>
      <div className="w-full flex justify-between items-center">
        <div className="flex gap-3 items-center">
          {data?.priceType === 0 ||
          data?.priceType === 1 ||
          data?.priceType === 6 ? (
            <>
              {" "}
              <img width={14} src="/images/icons/price.svg" alt="price" />
              <span className="text-sm text-[#4D4D4D]"> Price : </span>
              <span className="text-sm text-[#FF3400] font-bold">
                € {data?.price}
              </span>
            </>
          ) : data?.priceType === 5 ? (
            <span className="text-sm text-[#328d4a] font-bold">free</span>
          ) : data?.priceType === 3 ? (
            <span className="text-sm text-[#328d4a] font-bold">
              see description
            </span>
          ) : data?.priceType === 4 ? (
            <span className="text-sm text-[#328d4a] font-bold">swap</span>
          ) : (
            <></>
          )}
        </div>
        <div className="flex gap-3 items-center">
          {data?.deposite ? (
            <>
              {" "}
              <img width={14} src="/images/icons/deposite.svg" alt="price" />
              <span className="text-sm text-[#4D4D4D]"> Deposite : </span>
              <span className="text-sm text-[#FF3400] font-bold">
                € {data?.deposite}
              </span>{" "}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default Summery;
